import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-report\"><path d=\"M845.9 157.4h-672c-8.7 0-15.8 7.1-15.8 15.8v672c0 8.7 7.1 15.8 15.8 15.8h672c8.7 0 15.8-7.1 15.8-15.8v-672c0-8.7-7.1-15.8-15.8-15.8z m-48.2 639.7H222.1V221.4h575.7v575.7z\" /><path d=\"M285 306.2h64v64h-64zM413.1 306.2h321.7v64H413.1zM285 477.2h64v64h-64zM413.1 477.2h321.7v64H413.1zM285 648.2h64v64h-64zM413.1 648.2h321.7v64H413.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol